import { Draft, produce } from 'immer';

import { Action } from '../../actions';
import {
    ON_CLOSE_BANNER_PREVIEW_POPUP,
    ON_OPEN_BANNER_PREVIEW_POPUP
} from '../../actions/groups-edit/groups-edit-preview-banners';
import { EditGroupsState } from '../../typings/groupsEditState';

export function groupsEditPreviewBannersReducer(state: EditGroupsState, action: Action): EditGroupsState {
    return produce(state, (draft: Draft<EditGroupsState>) => {
        switch (action.type) {
            case ON_CLOSE_BANNER_PREVIEW_POPUP: {
                draft.groups[action.id].previewBanners.isBannersPopupVisible = false;

                break;
            }
            case ON_OPEN_BANNER_PREVIEW_POPUP: {
                draft.groups[action.id].previewBanners.isBannersPopupVisible = true;

                break;
            }

            default:
                break;
        }
    });
}
